import { InfiniteData } from "@tanstack/react-query";

import { AccountsMsSearchPrivilegesQuery } from "@/api/graphql/types/graphql.ts";

import { UserCompanyDetail } from "./types";

export const toUserCompaniesBO = (
  queryResponse: InfiniteData<AccountsMsSearchPrivilegesQuery | undefined>,
): Array<UserCompanyDetail> => {
  if (queryResponse) {
    return queryResponse.pages.reduce<Array<UserCompanyDetail>>((acc, page) => {
      const searchUsersOnCurrentPage =
        page?.AccountsMsSearchPrivileges.data &&
        page?.AccountsMsSearchPrivileges.data.length > 0
          ? page.AccountsMsSearchPrivileges.data.map<UserCompanyDetail>(
              (userCompany) => ({
                id: userCompany.id,
                lastUsedTs: userCompany.lastUsedTs,
                status: userCompany.status,
                invitedTs: userCompany.invitedTs,
                accountId: userCompany.accountId,
                accountName: userCompany?.AccountIdData?.name || "",
                accountNumber: userCompany?.AccountIdData?.number || "",
                subscriptions:
                  userCompany.Subscriptions?.map((subscription) => ({
                    roleName: subscription?.RolesProfileIdData?.name || "",
                    roleCode: subscription?.RolesProfileIdData?.code || "",
                  })) || [],
              }),
            )
          : [];

      if (searchUsersOnCurrentPage.length > 0) {
        acc.push(...searchUsersOnCurrentPage);
      }

      return acc;
    }, []);
  }

  return [];
};
